"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetDriveCompatibilityRequirementResultDetailsSchema = exports.NetDriveCompatibilityErrorSchema = void 0;
const ModuleSignalDriveMode_1 = require("./ModuleSignalDriveMode");
const zod_1 = require("zod");
exports.NetDriveCompatibilityErrorSchema = zod_1.z.object({
    type: zod_1.z.string(),
    message: zod_1.z.string().optional(),
});
exports.NetDriveCompatibilityRequirementResultDetailsSchema = zod_1.z.object({
    type: zod_1.z.literal('NetDriveCompatibilityResult'),
    net: zod_1.z.string(),
    modules: zod_1.z.array(ModuleSignalDriveMode_1.ModuleSignalDriveModeSchema),
    biasVoltage: zod_1.z.string().optional(),
    errors: zod_1.z.array(exports.NetDriveCompatibilityErrorSchema).optional(),
});
//# sourceMappingURL=NetDriveCompatibilityRequirementResultDetails.js.map